import React from "react";
import styled from "@emotion/styled";
import { mq } from "@utils/media-query/mediaQuery";
import { SUMMER_AWS_BUCKET_URL } from "@components/events/inspire-your-summer/InspireYourSummer";
import { EventButton } from "@components/events/event-templates/CommonStyling";
import { useMediaQuery } from "react-responsive";
import { DangerouslyHtml } from "@components/item";

const Container = styled.div(() => ({
  display: "flex",
  flexDirection: "column",

  gap: "1.2rem 12rem",
  padding: "3rem 2.5rem",
  background: "#ffffff",

  [mq("tablet")]: {
    flexDirection: "row",
    gap: "1.2rem 3rem",
    padding: "3rem 4rem",
  },

  [mq("desktop")]: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: "1.2rem 0rem",
    padding: "3rem 5rem",
  },
}));

const Texts = styled.div(() => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: "1rem 0",
  fontSize: "1.4rem",
  lineHeight: 1.3,
  fontWeight: 400,

  header: {
    color: "#000",
    fontSize: "2rem",
    fontWeight: 700,
  },

  [mq("tablet")]: {
    fontSize: "1.2rem",

    header: {
      fontWeight: 500,
      fontSize: "1.6rem",
    },
  },

  [mq("desktop")]: {
    gap: "2rem 0",
    fontSize: "1.8rem",

    header: {
      fontWeight: 500,
      fontSize: "3.6rem",
    },
  },
}));

const ImageWrapper = styled.div(() => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  gap: "1.6rem 0",
}));

const CardImage = styled.img(() => ({
  width: "80%",
  height: "auto",

  [mq("tablet")]: {
    width: "100%",
  },

  [mq("desktop")]: {
    width: "100%",
  },
}));

const ButtonWrapper = styled.div(() => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "0 1.4rem",
  width: "100%",
  marginTop: "1rem",

  [mq("tablet")]: {
    justifyContent: "flex-start",
  },

  [mq("desktop")]: {
    marginTop: "2rem",
    justifyContent: "flex-start",
  },
}));

const MomentumSection = ({ intlFormat }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <Container>
      <ImageWrapper>
        <CardImage
          src={`${SUMMER_AWS_BUCKET_URL}/membership_${isMobile ? "mobile" : "desktop"}.png`}
          alt="Take your rewards experience to the next level with Momentum Membership. Join for free to start enjoying exclusive benefits today."
        />
      </ImageWrapper>

      <Texts>
        <header>{intlFormat("winter-section8-title-1")}</header>

        <p>
          <DangerouslyHtml value={intlFormat("winter-section8-title-2")} />
        </p>

        <ButtonWrapper>
          <EventButton
            buttonName={intlFormat("lang-sign-up-now")}
            primary
            link="/momentum/join-momentum"
          />

          <EventButton link="/momentum/tiers-benefits" />
        </ButtonWrapper>
      </Texts>
    </Container>
  );
};

export default MomentumSection;
